import { forwardRef, useImperativeHandle, useRef } from 'react'
import classes from './Game.module.scss'
import NoteController from './components/NoteController';
import { AnimatePresence } from 'framer-motion';

const Game = forwardRef(function Game({ onAnswer }, ref) {

  const noteRef = useRef(null);

  useImperativeHandle(ref, () => ({
    animateEntry: async () => {
      await noteRef.current.animateEntry();
    }
  }));

  return (
    <div className={classes.gamecontainer}>
      <AnimatePresence>
        <NoteController
          ref={noteRef}
          onAnswer={onAnswer}
        />
      </AnimatePresence>
    </div>
  )
})

export default Game